import { createI18n } from 'vue-i18n'
import ro from './locales/ro.json'
import en from './locales/en.json'

export const i18n = createI18n({
  legacy: false,
  locale: 'ro',
  fallbackLocale: 'en',
  messages: {
    ro,
    en
  },
  datetimeFormats: {
    ro: {
      short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    en: {
      short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
    }
  },
  numberFormats: {
    ro: {
      currency: {
        style: 'currency',
        currency: 'RON',
        currencyDisplay: 'symbol'
      }
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'RON',
        currencyDisplay: 'symbol'
      }
    }
  }
})

export default i18n
